import Vue from 'vue';
import App from './App.vue';

import vuetify from '@/plugins/vuetify';

import router from './router';

Vue.config.productionTip = false;

new Vue({
    router,
    vuetify,
    render: h => h(App) // eslint-disable-line @typescript-eslint/explicit-function-return-type
}).$mount('#app');
